<figure class="academy-video">
  <div class="academy-video__frame" [class.is-plain]="video.kind === 'scenes'" [ngSwitch]="video.kind">
    <app-hint-film
      *ngSwitchCase="'hint'"
      class="academy-video__film"
      [animation]="film!"
      [width]="width || 320"
      [attr.aria-label]="label"
    ></app-hint-film>

    <app-academy-film
      *ngSwitchCase="'scenes'"
      class="academy-video__film"
      [scenes]="sceneRefs"
      [loop]="sceneRefs.length === 1"
      [captions]="captions"
      [label]="label"
    ></app-academy-film>

    <video
      *ngSwitchCase="'file'"
      class="academy-video__file"
      controls
      preload="metadata"
      [src]="fileVideo?.src"
      [attr.poster]="fileVideo?.poster || null"
      [attr.aria-label]="label"
    ></video>

    <!-- Noch kein Video: Orbi hält den Platz, bis die Lektion ihr Video bekommt. -->
    <div *ngSwitchDefault class="academy-video__placeholder" role="img" [attr.aria-label]="label">
      <app-orbi-lab type="tutor" [size]="88" [script]="placeholderScript" aria-hidden="true"></app-orbi-lab>
      <span class="academy-video__soon">{{ 'academy.video.soon' | translate }}</span>
    </div>
  </div>
  <figcaption class="academy-video__caption" *ngIf="video.kind !== 'scenes'">
    <nb-icon icon="film-outline"></nb-icon>
    <span>{{ (video.kind === 'hint' ? 'academy.video.hintFilm' : 'academy.video.explainer') | translate }}</span>
    <span *ngIf="seconds" class="academy-video__duration">· {{ duration }}</span>
  </figcaption>
</figure>
